import { BrowserRouter, Routes, Route } from "react-router-dom";
import Navbar from "./components/Navbar";
import Footer from "./components/Footer";
import Home from "./pages/Home";
import Text2SQLWithData from "./pages/Text2SQL";
import SQL2Text from "./pages/SQL2Text";
import Pricing from "./pages/Pricing";
import AboutUs from "./pages/AboutUs";
import ContactUs from "./pages/ContactUs";
import "./index.css";
import Login from "./pages/Login";
import Register from "./pages/Register";
import ForgotPassword from "./pages/ForgotPass";
import ResetPassword from "./pages/ResetPass";
import Profile from "./pages/Profile";
import ProfileUpdate from "./pages/ProfileUpdate";
import PrivateRoute, { PublicRoute } from "./components/PrivateRoute";
import QueryHistory from "./pages/QueryHistory";

function App() {
  const BASE_PATH = process.env.REACT_APP_BASE_PATH

  return (
    <>
      <BrowserRouter basename={BASE_PATH}>
        <div className="flex flex-col min-h-screen">
          <Navbar />
          <main className="flex-grow">
            <Routes>
              {/* PUBLIC OPEN ROUTES */}
              <Route path="/" element={<Home />} />
              <Route path="/pricing" element={<Pricing />} />
              <Route path="/about-us" element={<AboutUs />} />
              <Route path="/contact-us" element={<ContactUs />} />
              {/* PUBLIC AUTH ROUTES */}
              <Route element={<PublicRoute />}>
                <Route path="/login" element={<Login />} />
                <Route path="/register" element={<Register />} />
                <Route path="/forgot-password" element={<ForgotPassword />} />
                <Route path="/reset-password" element={<ResetPassword />} />
              </Route>

              {/* PRIVATE ROUTES */}
              <Route element={<PrivateRoute />}>
                <Route path="/profile" element={<Profile />} />
                <Route path="/query-history" element={<QueryHistory />} />
                <Route path="/profile-update" element={<ProfileUpdate />} />
                <Route path="/convert-text-2-sql" element={<Text2SQLWithData />} />
                <Route path="/convert-sql-2-text" element={<SQL2Text />} />
              </Route>
            </Routes>
          </main>
          <Footer />
        </div>
      </BrowserRouter >
      <a
        href=" https://web.whatsapp.com/send?phone=447459302492&text=Hello,%20I%20need%20help%20with%20Uplatz%20AI%20ResumeFit."
        target="_blank"
        rel="noopener noreferrer"
        style={{
          position: "fixed",
          bottom: "20px",
          right: "20px",
          backgroundColor: "#25D366",
          color: "white",
          borderRadius: "50%",
          padding: "15px",
          fontSize: "25px",
          textAlign: "center",
          boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.3)",
          zIndex: 1000,
        }}
      >
        <img
          src="https://upload.wikimedia.org/wikipedia/commons/6/6b/WhatsApp.svg"
          width={35}
          alt="WhatsApp"
        />
      </a>
    </>
  );
}

export default App;
